import { PartnersI18n } from '@/locales/base.message.locales';

export const partners: PartnersI18n = {
  title: 'Partnerships',
  text: 'Partners are solution ecosystems for each of the 17 SDGs who support IKONE TEAMS or solve with them challenges creating models to scale around the world.',
  bop_hub: {
    title: 'BoP Hub',
    text: `
                 BoP Hub was established with a vision to design business to end poverty.
        A Singapore-based business accelerator platform, our mission is to create
        an efficient marketplace for communities at the base of the pyramid by
        supporting entrepreneurship, connecting partners and sharing resources.
        To that end, BoP Hub serves as a gateway for business ventures, technologists,
        and manufacturers to access BoP markets. We work to aggregate and bundle products
        with distribution, logistics, economies of scale, public policy, design, and
        technology in order to complete the supply chain and more effectively deliver much
        needed goods and services to consumers at the base of the pyramid.
        `,
  },
  cure: {
    title: 'Project C.U.R.E',
    text: `
                Thousands of people die every day in the developing world because local
        hospitals & clinics don’t have the medical supplies and equipment needed
        to save lives in their communities. Children are missing the chance to get
        an education and live a full life due to illnesses that would be treatable
        if they had access to proper health services. It’s Project C.U.R.E.’s mission
        to change that. Together we will deliver health & hope to the world.`,
  },
  exito_institute: {
    title: 'Êxito Institute',
    text: `
        The ÊXITO INSTITUTE was founded by thirty-four visionary entrepreneurs on February 18, 2019. We are dedicated to encouraging and supporting entrepreneurship, free enterprise and business ethics. We believe that great entrepreneurs have an important contribution to make: share their experience so that each person can discover the entrepreneur that exists within them.`,
  },
  northwestern: {
    title: 'Northwestern University',
    text: `Northwestern is a large research university with a comprehensive doctoral
        program, attracting nearly $800 million in sponsored research each year.
        As of 2018, Northwestern has the tenth-largest university endowment in the United
        States, valued at a record $11.08 billion. The university's former and present
        faculty and alumni include 19 Nobel Prize laureates, 38 Pulitzer Prize winners,
        six MacArthur Genius Fellows, 16 Rhodes Scholars, 65 members of the American Academy
        of Arts and Sciences and two Supreme Court Justices.
        `,
  },
  porto_social: {
    title: 'Porto Social',
    text: `
                We have the name “Port” because it is in Ports that people come and go. In
        these comings and goings they get emotionally supplied, leave loads, get
        resources, train themselves, build relationships to face new journeys.
        We are a “Social Harbor” - the place to bring together everyone who is
        changing the world through social initiatives. They use the term incubator
        and accelerator to define who we are, but our challenge is to care for and
        empower the 'world-change.
        `,
  },
  singularity: {
    title: 'Singularity University',
    text: `
        Singularity University is a global learning and innovation community using
        exponential technologies to tackle the world’s biggest challenges and build
        a better future for all. Our collaborative platform empowers individuals and
        organizations across the globe to learn, connect, and innovate breakthrough
        solutions using accelerating technologies like artificial intelligence,
        robotics, and digital biology. We offer educational programs, courses, and
        summits; enterprise strategy, leadership, and innovation programs; programs
        to support and scale startups and promote social impact; and online news and
        content.`,
  },
  terra: {
    title: 'Fundação Terra',
    text: `
                The Terra Foundation was created by Fr. Airton Freire, 34 years old, on
        September 8, 1984, in a community popularly known as “Rua do Lixo” and
        which is located near the industrial waste dump (“Lixão”) from the city
        of Arcoverde, in the semi-arid state of Pernambuco. It was born in this
        community in order to literally rescue trash, men, women and children,
        use as a supreme juice of the misery of the city of Arcoverde. It was
        founded to serve the poor. Its motto is: “On Earth to Serve”; serve the
        poor through education, health and social actions, with a view to overcoming
        social exclusion and promoting dignity, perpetuating or indistinctly doing
        good. It is a nonprofit, philanthropic Roman Catholic confession civil entity
        that has a municipal, state and federal public utility certificate.`,
  },
  transforma: {
    title: 'Transforma Brasil',
    text: `
                They are a movement that aims to encourage volunteerism and civic engagement
        in Brazil. Transforma Brasil's mission is to transform Brazil through Brazilians.
        What drives them is solidarity, the willingness to connect people who need help
        with others who want to help. Transforma Brasil are all of us: citizens and
        social initiatives in the construction of an increasingly better and more
        solidary world.`,
  },
  walk: {
    title: 'Operation Walk Chicago',
    text: `
    Founded by Victoria Anne Brander MD and S. David Stulberg MD, Operation Walk Chicago was as mission to improve the quality of life of disadvantaged patients around the world through reducing disability from advanced joint disease. Operation Walk Chicago commits to ongoing education and patient care in these impoverished communities, to ensure its contribution will have a long lasting effect. Operation Walk Chicago strives to use only the highest quality educators, administrators, clinicians and equipment, and partners with in-country clinicians to develop a program of arthritis care that is practical and sustainable.`,
  },

  trata_brasil: {
    title: 'Trata Brasil',
    text: `
                The Trata Brasil Institute is an OSCIP - Civil Society Organization of Public Interest,
        formed by companies interested in advancing basic sanitation and protection of water resources in the country.
                Since 2007, working so that the citizen is informed and demands the universalization of the most basic
        service, essential for any nation: basic sanitation.
                Our job is to make society aware of the fact that Brazil is more just, with everyone having access to
        treated water, sewage collection and treatment.
                We are still a very uneven country in this infrastructure, especially in the poorest regions.`,
  },

  world_toilet: {
    title: 'World Toilet Organization',
    text: `
        Founded on 19 November 2001, World Toilet Organization (WTO) is a global non-profit committed to improving toilet and sanitation conditions worldwide. WTO empowers individuals through education,
        training and building local marketplace opportunities to advocate for clean and safe sanitation facilities in their communities. Breaking the silence on the sanitation crisis is at the heart of WTO's efforts. WTO established World Toilet Day and the World Toilet Summit in 2001; this was followed by the World Toilet College in 2005.`,
  },
};
